module.exports = __webpack_public_path__ + "img/scheme_mob.8675576.webp";